import { useTranslation } from 'react-i18next';
import styles from './SkipLink.module.css';

export const SkipLink = () => {
    const { t } = useTranslation();

    return (
        <a href="#main-content" className={styles.skipLink}>
            {t('a11y.skipToContent')}
        </a>
    );
};
